import React from 'react';
import { Button } from '@material-ui/core';
import { EditRowButtonsDiv } from '../style/WrapperDiv';
import defaults from '../../../translations/en.json';

type EditRowButtonsProps = {
  onCancelClick: () => void;
  onConfirmClick: () => void;
  disabled?: boolean;
};

export const EditRowButtons = ({
  onCancelClick,
  onConfirmClick,
  disabled,
}: EditRowButtonsProps) => (
  <EditRowButtonsDiv>
    <Button
      title="OK"
      size="small"
      variant="contained"
      color="primary"
      disabled={disabled}
      onClick={onConfirmClick}
    >
      {defaults.confirm}
    </Button>
    <Button
      title="Cancel"
      size="small"
      variant="contained"
      color="primary"
      onClick={onCancelClick}
    >
      {defaults.cancel}
    </Button>
  </EditRowButtonsDiv>
);
